import React from 'react'
import styled from 'styled-components'

import { SkeletonRect } from 'components/Skeleton/SkeletonLoader'

const SKELETON_ROW_COUNT = 8

const VideoListSkeletonRow = (): JSX.Element => (
  <Row
    aria-hidden='true'
    role='presentation'
  >
    <Col className='col1'>
      <SkeletonRect height='48px' width='85px' />
    </Col>
    <Col className='col2'>
      <SkeletonRect height='20px' width='70%' />
    </Col>
    <Col className='col3'>
      <SkeletonRect height='20px' width='40px' />
    </Col>
    <Col className='col4'>
      <SkeletonRect height='24px' width='56px' />
    </Col>
    <Col className='col5'>
      <SkeletonRect height='24px' width='52px' />
    </Col>
    <Col className='col6'>
      <SkeletonRect height='20px' width='20px' />
    </Col>
    <Col className='col7'>
      <SkeletonRect height='20px' width='54px' />
    </Col>
  </Row>
)

export const VideoListSkeleton = (): JSX.Element => (
  <Container
    aria-busy='true'
    aria-label='Loading videos'
    role='status'
  >
    {Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
      <VideoListSkeletonRow key={`video-list-skeleton-row-${index}`} />
    ))}
  </Container>
)

export default VideoListSkeleton

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 8px;
`

const Col = styled.div`
  display: flex;
  align-items: center;

  &.col1 {
    width: 10%;
    flex: none;
  }

  &.col2 {
    width: 43%;
    flex: none;
  }

  &.col3 {
    width: 10%;
    flex: none;
    justify-content: center;
  }

  &.col4 {
    width: 10%;
    flex: none;
    justify-content: center;
  }

  &.col5 {
    width: 10%;
    flex: none;
    justify-content: center;
  }

  &.col6 {
    width: 5%;
    flex: none;
    justify-content: center;
  }

  &.col7 {
    width: 10%;
    flex: none;
    justify-content: flex-end;
  }
`
